var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRfzoLogo = function SvgRfzoLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1251 0H6.75911C5.39349 0 4.02788 0.565481 3.04694 1.55507C1.98907 2.58506 0.23877 4.98835 0.23877 4.98835H10.1251H13.4718C14.8374 4.98835 16.203 4.42287 17.184 3.43328C18.2418 2.40329 20.0114 0 20.0114 0H10.1251Z",
    fill: "#016136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.23877 15.3689V18.883C0.23877 20.3169 0.777323 21.7508 1.71979 22.7807C2.71996 23.8915 5.00881 25.7293 5.00881 25.7293V15.3689V11.8548C5.00881 10.4209 4.47026 8.98704 3.52779 7.95706C2.52762 6.84629 0.23877 4.98828 0.23877 4.98828V15.3689Z",
    fill: "#B11016"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8763 25.7498H18.2231C19.5887 25.7498 20.9543 25.1843 21.9352 24.1947C22.9931 23.1445 24.7434 20.7412 24.7434 20.7412H14.8763H11.5296C10.164 20.7412 8.79839 21.3067 7.81745 22.2963C6.75958 23.3465 5.00928 25.7498 5.00928 25.7498H14.8763Z",
    fill: "#7BA8DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7617 12.3197V12.8044C24.7617 11.3705 24.2232 9.93657 23.2807 8.90659C22.2806 7.79582 19.9917 5.95801 19.9917 5.95801V12.3197V13.9151C19.9917 15.349 20.5303 16.7829 21.4727 17.8129C22.4729 18.9237 24.7617 20.7615 24.7617 20.7615V12.3197Z",
    fill: "#BBCCEA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRfzoLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rfzo_logo.8f431391.svg";
export { ForwardRef as ReactComponent };